var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from '@mui/material/SvgIcon';
var path = (_jsxs("svg", { width: '700', height: '700', viewBox: '0 0 700 700', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [_jsx("path", { d: 'M0 0H325V325H0V0Z', fill: '#F35325' }), _jsx("path", { d: 'M375 0H700V325H375V0Z', fill: '#81BC06' }), _jsx("path", { d: 'M0 375H325V700H0V375Z', fill: '#05A6F0' }), _jsx("path", { d: 'M375 375H700V700H375V375Z', fill: '#FFBA08' })] }));
var loginButtonIcon = function (props) {
    return _jsx(SvgIcon, __assign({}, props, { children: path }));
};
export default loginButtonIcon;
